import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    /**
     * Sets a cookie.
     * @param name Name of the cookie
     * @param value Value of the cookie
     * @param days Optional expiration in days
     */
    setCookie(name: string, value: string, days?: number): void {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }

        const isLocalhost = window.location.hostname === 'localhost';
        const securityFlags = isLocalhost ? '' : '; SameSite=Lax; Secure';

        const encodedValue = encodeURIComponent(value || '');

        document.cookie = `${name}=${encodedValue}${expires}; path=/${securityFlags}`;
    }

    setJsonCookie(name: string, value: unknown, days?: number): void {
        this.setCookie(name, JSON.stringify(value), days);
    }

    /**
     * Gets a cookie by name.
     * @param name Name of the cookie
     * @returns Value or null
     */
    getCookie(name: string): string | null {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    getJsonCookie<T>(name: string): T | null {
        const cookieValue = this.getCookie(name);

        if (!cookieValue) {
            return null;
        }

        try {
            return JSON.parse(cookieValue) as T;
        } catch {
            return null;
        }
    }

    /**
     * Deletes a cookie by name.
     * @param name Name of the cookie
     */
    deleteCookie(name: string): void {
        const isLocalhost = window.location.hostname === 'localhost';
        const securityFlags = isLocalhost ? '' : '; SameSite=Lax; Secure';
        document.cookie = `${name}=; Max-Age=-99999999; path=/${securityFlags}`;
    }
}
